module.exports = __webpack_public_path__ + "static/media/team-swimmy-raphaelle.96ab5cc7.png";